<div class="pseudo-container bootstrap">
  <div class="row1">
    <app-apg-sum-assured (sumAssuredChanged)="sumAssuredChanged($event)"></app-apg-sum-assured>
    <app-apg-conditions (conditionAdded)="addCondition($event)" (resetGraph)="resetGraph()"></app-apg-conditions>
  </div>

  <div class="row results" *ngIf="results$ | async as results">
    <div class="col">
      <app-apg-benefit-payments [results]="results"></app-apg-benefit-payments>
    </div>
    <div class="col">
      <app-apg-graph [results]="results"></app-apg-graph>
    </div>
  </div>

  <div class="note">* A related Death is a death caused or related to a previously claimed for Major Condition.</div>
</div>
